/* Twiggy Shop: WhatsApp / Viber "ask about this product" buttons (product page). Ported from iArena 2026-10-17. */
(function () {
  function init(box) {
    var digits = box.getAttribute('data-digits');
    var msg = box.getAttribute('data-msg');
    var title = box.getAttribute('data-title');
    var url = box.getAttribute('data-url');
    var sizeLabel = box.getAttribute('data-size-label') || '';
    var variants = {};
    try { variants = JSON.parse((box.querySelector('[data-tw-variants]') || {}).textContent || '{}'); } catch (e) {}
    function selectedVariant() {
      // Pipeline keeps the live variant in the hidden input of the product form and mirrors it into ?variant=
      var el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (el && el.value && variants[el.value]) return { id: el.value, v: variants[el.value] };
      var m = location.search.match(/variant=(\d+)/);
      if (m && variants[m[1]]) return { id: m[1], v: variants[m[1]] };
      var sel = document.querySelector('form[action*="/cart/add"] select[name="id"]');
      if (sel && sel.value && variants[sel.value]) return { id: sel.value, v: variants[sel.value] };
      return null;
    }
    function text() {
      var sel = selectedVariant();
      var s = msg + ' ' + title;
      var link = url;
      if (sel) {
        if (sel.v.t && sel.v.t !== 'Default Title') s += ', ' + sizeLabel + sel.v.t;
        s += ' — ' + sel.v.p;
        link += '?variant=' + sel.id;
      }
      return s + '\n' + link;
    }
    function copy(t) {
      try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t); } catch (e) {}
    }
    function toast() {
      var el = box.querySelector('.tw-chat__toast');
      if (!el) return;
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.hidden = true; }, 6000);
    }
    box.querySelectorAll('[data-tw-chat]').forEach(function (a) {
      a.addEventListener('click', function () {
        var t = text();
        var isWa = a.getAttribute('data-tw-chat') === 'wa';
        if (isWa) {
          a.href = 'https://wa.me/' + digits + '?text=' + encodeURIComponent(t);
        } else {
          a.href = 'viber://chat?number=' + encodeURIComponent('+' + digits) + '&text=' + encodeURIComponent(t);
          copy(t);
          toast();
        }
        if (window.gtag) { try { gtag('event', 'contact_click', { method: isWa ? 'whatsapp' : 'viber', item_name: title }); } catch (e) {} }
      });
    });
  }
  function run() { document.querySelectorAll('.tw-chat').forEach(function (b) { if (!b._twChat) { b._twChat = 1; init(b); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
